import UserService from "@/services/UserService";

/* jshint ignore:start */
/* eslint-disable */

const state = {
  isLogin: false,
  loginSuccess: false,
  loginErrorMsg: "",
  shopList: []
};

const getters = {

};

const mutations = {
  login(state, { success, msgErr, shopLists,dataToken }) {
    state.loginSuccess = success;
    state.loginErrorMsg = success ? "" : msgErr;
    state.shopList = shopLists;
    state.isLogin = dataToken;
  },
  checklogin(state, { data }) {
    state.isLogin = data;
  },
  authlogout(state){
    state.isLogin= false,
    state.loginSuccess= false,
    state.loginErrorMsg= "",
    state.shopList= []
  }
};

const actions = {
  async login({ commit }, { username, password }) {
    let loginSuccess = false,
      errorMsg = "",
      shoplistx = [],
      token = "";
    await UserService.checkLogin(username, password)
      .then(response => {
        console.log(response)
        if (response && response.data.token != undefined) {
          loginSuccess = true;
          localStorage._token = response.data.token;
          token = response.data.token;
        } else {
          loginSuccess = false;
          errorMsg = "Username or password is wrong !";
        }
      })
      .catch(err => {
        loginSuccess = false;
        errorMsg = err;
      });

    await UserService.getCompany(token)
      .then(res => {
        console.log(res)
        if (res && res.data != undefined) {
          shoplistx = res.data;
        }
      })
      .catch(err => {
        loginSuccess = false;
        errorMsg = err;
      });

    await commit("login", {
      success: loginSuccess,
      msgErr: errorMsg,
      shopLists: shoplistx,
      dataToken:token
    });
  },
  checklogin({ commit }){

    let data = false;
    if (localStorage._token != undefined && localStorage._token != "") {
        data = true;
    }else{
        data = false;
    }
    commit("checklogin", {
        data:data
      });

  }
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};
